<template>
  <core-header-dropdown no-caret right>
    <template #header>
      <font-awesome-icon :icon="['fal', 'alarm-exclamation']" />
      <b-badge v-if="itemsCount" pill variant="warning">{{ itemsCount }}</b-badge>
    </template>

    <template #dropdown>
      <b-dropdown-header class="dropdown-menu-lg text-center" tag="div">
        <b>{{ itemsCount === 0 ? "No" : itemsCount }} Pending Reminders</b>
      </b-dropdown-header>

      <b-dropdown-item>
        <button class="btn btn-primary btn-sm" @click.prevent.stop="switchType">
          Showing {{ type === "all" ? "All" : "Mine" }}
        </button>
      </b-dropdown-item>

      <b-dropdown-item
        v-for="reminder in reminders"
        v-show="!isFuture(reminder.due_date)"
        :key="`past-${reminder.id}`"
        @click.prevent="open(reminder.id)"
      >
        <font-awesome-icon
          v-if="reminder.important"
          :icon="['fal', 'exclamation-triangle']"
          class="text-danger"
        />
        #{{ reminder.job_id }}J {{ reminder.action }},
        <span :class="isPast(reminder.due_date) ? 'text-warning' : ''">
          {{ relativeTime(reminder.due_date) }}
        </span>

        <font-awesome-icon
          :icon="['fal', 'thumbs-up']"
          class="text-info float-right hover-only adjust-icon"
          @click.prevent.stop="resolve(reminder.id)"
        />
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item
        v-for="reminder in reminders"
        v-show="isFuture(reminder.due_date)"
        :key="`future-${reminder.id}`"
        @click.prevent="open(reminder.id)"
      >
        <font-awesome-icon
          v-if="reminder.important"
          :icon="['fal', 'exclamation-triangle']"
          class="text-danger"
        />
        #{{ reminder.job_id }}J {{ reminder.action }},
        <span :class="isPast(reminder.due_date) ? 'text-warning' : ''">
          {{ relativeTime(reminder.due_date) }}
        </span>

        <font-awesome-icon
          :icon="['fal', 'thumbs-up']"
          class="text-info float-right hover-only adjust-icon"
          @click.prevent.stop="resolve(reminder.id)"
        />
      </b-dropdown-item>

      <b-dropdown-item @click.prevent="openList">
        <b>View All Reminders</b>

        <b-button
          v-b-modal.new-reminder
          class="btn btn-primary float-right adjust-button"
          size="sm"
          @click.prevent.stop
        >
          <font-awesome-icon :icon="['fal', 'plus-circle']" class="exclude-genesis" />
          Add
        </b-button>
      </b-dropdown-item>
    </template>
  </core-header-dropdown>
</template>

<script>
import moment from "moment";
import { HeaderDropdown as CoreHeaderDropdown } from "@coreui/vue";
import EventBus from "../../imports/event-bus";

export default {
  components: {
    CoreHeaderDropdown,
  },

  data() {
    return {
      type: "my",

      reminders: [],
      itemsCount: 0,
    };
  },

  mounted() {
    this.init();

    EventBus.$on("reminder-updated", () => {
      this.init();
    });
  },

  methods: {
    init() {
      if (localStorage.type) {
        this.type = localStorage.type;
      }

      const type = `type=${this.type}`;

      this.$http.get(`/reminders?limit=5&&resolved=false&${type}`).then((response) => {
        this.reminders = response.body.data;
        this.itemsCount = this.$lodash.get(response, "body.pending_count");
      });
    },

    isPast(date) {
      return moment(date).diff(moment().format("YYYY-MM-DD"), "days") < 0;
    },

    isFuture(date) {
      return moment(date).diff(moment().format("YYYY-MM-DD"), "days") > 0;
    },

    relativeTime(date) {
      const diff = moment(date).diff(moment().format("YYYY-MM-DD"), "days");

      if (diff === 0) {
        return "Today";
      }

      if (diff === -1) {
        return "Yesterday";
      }

      if (diff === 1) {
        return "Tomorrow";
      }

      if (diff < -1) {
        return `${0 - diff} days ago`;
      }

      if (diff > 1) {
        return `In ${diff} days`;
      }

      return diff;
    },

    add() {
      // noinspection JSUnresolvedFunction
      this.$refs.newReminderModalRef.show();
    },

    open(id) {
      window.open(`/reminders/${id}/edit`);
    },

    openList() {
      window.open("/reminders/list");
    },

    switchType() {
      this.type = this.type === "all" ? "my" : "all";
      localStorage.type = this.type;

      this.init();
    },

    resolve(id) {
      window
        .sweetAlert({
          title: "Confirm to resolve this reminder",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "No",
            confirm: "Yes!",
          },
        })
        .then((confirmed) => {
          if (confirmed) {
            this.$http.put(`/reminders/${id}/resolve`).then((response) => {
              if (response.status === 200) {
                window.toastr.success("Reminder resolved!", "Success");
                EventBus.$emit("reminder-updated");
              } else {
                window.toastr.warning(
                  "Something went wrong when trying to resolve this reminder!",
                  "Warning"
                );
              }
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.dropdown-item {
  padding: 10px 15px;
}

.hover-only {
  display: none;
}

.dropdown-item:hover .hover-only {
  display: block;
}

.adjust-icon {
  position: relative;
  top: 4px;

  &:hover {
    font-weight: bold;
  }
}

.adjust-button {
  position: relative;
  top: -4px;
}

// Revert Genesis change
i.exclude-genesis {
  width: auto;
  margin-right: 0;
  margin-left: 0;
  color: inherit;
}
</style>
